import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { toast } from 'sonner';
import { KeyRound, CheckCircle2, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ResetPassword = () => {
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token') || '';
    setToken(t);
    if (!t) toast.error('Reset link is missing a token.');
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error('Invalid reset link');
    if (!password || password.length < 6) return toast.error('Password must be at least 6 characters');
    if (password !== confirm) return toast.error('Passwords do not match');
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setDone(true);
      toast.success('Password reset successfully! You can now log in.');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Reset failed. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  const goToLogin = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="w-full max-w-md">
        <Card className="border-0 shadow-2xl">
          <CardHeader>
            <div className="flex justify-center mb-2">
              <div className="p-3 rounded-full bg-blue-100">
                {done ? <CheckCircle2 className="h-6 w-6 text-green-600" /> : <KeyRound className="h-6 w-6 text-blue-600" />}
              </div>
            </div>
            <CardTitle className="text-2xl text-center">{done ? 'Password Reset' : 'Set a New Password'}</CardTitle>
            <CardDescription className="text-center">
              {done ? 'Your password has been changed. You can log in with your new password.' : 'Choose a new, strong password for your account.'}
            </CardDescription>
          </CardHeader>
          <CardContent>
            {done ? (
              <Button onClick={goToLogin} className="w-full" data-testid="reset-to-login-btn">Go to Login</Button>
            ) : (
              <form onSubmit={submit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="np">New Password</Label>
                  <Input id="np" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                    placeholder="At least 6 characters" data-testid="reset-new-password" required />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="cp">Confirm New Password</Label>
                  <Input id="cp" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                    data-testid="reset-confirm-password" required />
                </div>
                <Button type="submit" disabled={loading} className="w-full" data-testid="reset-submit-btn">
                  {loading ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Resetting...</> : 'Reset Password'}
                </Button>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ResetPassword;
